/* Siryana — scripts du thème */
(function () {
  'use strict';
  var S = window.Siryana || (window.Siryana = {});
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  S.$ = $; S.$$ = $$;

  /* ---------- Outils ---------- */
  var fmt;
  try { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: S.currency || 'EUR' }); }
  catch (e) { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }); }
  S.money = function (cents) { return fmt.format((cents || 0) / 100); };
  S.pct = function (v) { return v ? '-' + String(v).replace('.', ',') + '%' : '0%'; };
  S.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Paliers « 2:5|3:7.5|4:10|5:15 » -> [[2,5],[3,7.5],...]
  S.parseTiers = function (txt) {
    return String(txt || '').split('|').map(function (x) { return x.split(':').map(function (n) { return parseFloat(String(n).replace(',', '.')); }); })
      .filter(function (t) { return t[0] > 0 && t[1] >= 0; }).sort(function (a, b) { return a[0] - b[0]; });
  };
  S.tiers = S.parseTiers(S.tiers);
  S.discountFor = function (n, tiers) { var r = 0; (tiers || S.tiers).forEach(function (t) { if (n >= t[0]) r = t[1]; }); return r; };
  S.nextTier = function (n, tiers) { var nx = null; (tiers || S.tiers).forEach(function (t) { if (!nx && n < t[0]) nx = t; }); return nx; };
  S.codeFor = function (n) {
    var code = null;
    String(S.codes || '').split('|').forEach(function (x) { var p = x.split(':'); if (p.length === 2 && n >= +p[0]) code = p[1].trim(); });
    return code;
  };

  S.toast = function (msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._t); t._t = setTimeout(function () { t.hidden = true; }, 2600);
  };

  /* ---------- Panier (API Ajax) ---------- */
  S.cart = {
    add: function (items) {
      return fetch(S.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    change: function (key, qty) {
      return fetch(S.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    },
    get: function () { return fetch(S.routes.cart + '.js').then(function (r) { return r.json(); }); }
  };

  S.refreshCart = function (open) {
    var drawer = $('[data-cart-drawer]');
    var url = S.routes.root + '?sections=cart-drawer';
    var p1 = drawer ? fetch(url).then(function (r) { return r.json(); }).then(function (data) {
      var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      var fresh = html.querySelector('[data-cart-inner]');
      var cur = $('[data-cart-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }) : Promise.resolve();
    var p2 = S.cart.get().then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
      return c;
    });
    return Promise.all([p1, p2]).then(function () { if (open) S.openCart(); });
  };

  S.openCart = function () {
    var d = $('[data-cart-drawer]');
    if (!d || S.cartType === 'page') { window.location.href = S.routes.cart; return; }
    S.openDrawer(d);
  };

  S.addToCart = function (items, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    return S.cart.add(items).then(function () {
      return S.refreshCart(true);
    }).catch(function (err) {
      S.toast((err && (err.description || err.message)) || S.strings.error);
    }).then(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  };

  /* ---------- Tiroirs (menu, panier) ---------- */
  var lastFocus;
  S.openDrawer = function (d) {
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var f = $('button, a, input', $('.drawer__panel', d)); if (f) setTimeout(function () { f.focus(); }, 50);
  };
  S.closeDrawer = function (d) {
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 350);
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { var d = document.getElementById(o.getAttribute('data-open-drawer')); if (d) { e.preventDefault(); S.openDrawer(d); } return; }
    var c = e.target.closest('[data-close-drawer]');
    if (c) { S.closeDrawer(c.closest('.drawer')); return; }
    var cartLink = e.target.closest('[data-cart-link]');
    if (cartLink && $('[data-cart-drawer]') && S.cartType === 'drawer') { e.preventDefault(); S.openCart(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(S.closeDrawer);
  });

  /* Lignes du panier (tiroir et page) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (!b) return;
    var line = b.closest('[data-line]');
    var key = line.getAttribute('data-line');
    var input = $('input', line);
    var q = Math.max(0, (+input.value || 0) + (+b.getAttribute('data-line-qty')));
    if (b.hasAttribute('data-remove')) q = 0;
    line.style.opacity = '.5';
    S.cart.change(key, q).then(function () {
      if (document.body.classList.contains('tpl-cart')) window.location.reload();
      else S.refreshCart(false);
    });
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line] input');
    if (!input) return;
    var line = input.closest('[data-line]');
    S.cart.change(line.getAttribute('data-line'), Math.max(0, +input.value || 0)).then(function () {
      if (document.body.classList.contains('tpl-cart')) window.location.reload(); else S.refreshCart(false);
    });
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    fetch(S.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
  });

  /* Ajout rapide depuis une carte produit */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    S.addToCart([{ id: +b.getAttribute('data-quick-add'), quantity: 1 }], b);
  });

  /* ---------- Barre d'annonce ---------- */
  function initAnnouncement(root) {
    var slides = $$('.ann__slide', root);
    if (slides.length < 2 || root.classList.contains('ann--static')) return;
    var i = 0, speed = (+root.getAttribute('data-speed') || 4) * 1000, timer;
    function next() {
      var prev = slides[i];
      prev.classList.remove('is-active'); prev.classList.add('is-leaving');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 500);
      i = (i + 1) % slides.length; slides[i].classList.add('is-active');
    }
    function start() { stop(); timer = setInterval(next, speed); }
    function stop() { clearInterval(timer); }
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    start();
  }

  /* ---------- En-tête collant ---------- */
  function initHeader(root) {
    var hdr = $('.hdr', root); if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Carrousels ---------- */
  function initSlider(root) {
    var track = $('.slider__track', root); if (!track) return;
    var prevs = $$('[data-prev]', root), nexts = $$('[data-next]', root), dots = $('.dots', root);
    var slides = Array.prototype.slice.call(track.children);
    function step() { return slides[0] ? slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prevs.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      nexts.forEach(function (b) { b.disabled = track.scrollLeft >= max; });
      if (dots) {
        var idx = Math.round(track.scrollLeft / step());
        $$('button', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === Math.min(idx, slides.length - 1)); });
      }
    }
    if (dots && !dots.children.length) {
      slides.forEach(function (_, k) {
        var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Diapositive ' + (k + 1));
        d.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); });
        dots.appendChild(d);
      });
    }
    prevs.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    root._sliderGo = function (k) { track.scrollTo({ left: k * step(), behavior: 'smooth' }); };
  }

  /* ---------- Onglets ---------- */
  function initTabs(root) {
    var tabs = $$('[role="tab"]', root);
    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); activate(n, true); }
      });
    });
  }

  /* ---------- Senteurs (liste qui change l'image et le texte) ---------- */
  function initScents(root) {
    var items = $$('[data-scent]', root);
    function show(k) {
      items.forEach(function (it, i) { it.setAttribute('aria-selected', i === k); });
      $$('[data-scent-panel]', root).forEach(function (p, i) { p.classList.toggle('is-active', i === k); });
      $$('[data-scent-media]', root).forEach(function (p, i) { p.classList.toggle('is-active', i === k); });
    }
    items.forEach(function (it, k) {
      it.addEventListener('click', function () { show(k); });
      it.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) show(k); });
    });
  }

  /* ---------- Formulaire produit (variantes, quantité, ajout) ---------- */
  function initProduct(root) {
    var dataEl = $('[data-product-json]', root); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('[data-product-form]', root);
    if (!form) return;
    var idInput = $('[name="id"]', form);
    var qtyInput = $('[data-qty]', root);
    function currentOptions() {
      return $$('[data-option-index]', root).map(function (g) {
        var c = $('input:checked', g) || $('select', g); return c ? c.value : null;
      });
    }
    function findVariant() {
      var opts = currentOptions();
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0];
    }
    function update() {
      var v = findVariant(); if (!v) return;
      idInput.value = v.id;
      $$('[data-price]', root).forEach(function (el) { el.innerHTML = priceHtml(v); });
      $$('[data-atc]', root).forEach(function (b) {
        b.disabled = !v.available;
        var lab = $('[data-atc-label]', b); if (lab) lab.textContent = v.available ? lab.getAttribute('data-default') : S.strings.soldOut;
      });
      $$('[data-option-index]', root).forEach(function (g, i) { var lbl = $('[data-option-value]', g); if (lbl) lbl.textContent = v.options[i]; });
      if (v.featured_media) {
        var slide = $('[data-media-id="' + v.featured_media.id + '"]', root);
        var gal = slide && slide.closest('.slider');
        if (slide && gal && gal._sliderGo) gal._sliderGo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
      }
      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:change', { detail: v, bubbles: true }));
    }
    function priceHtml(v) {
      var sale = v.compare_at_price > v.price;
      return '<span class="price' + (sale ? ' price--sale' : '') + '">' + (sale ? '<s>' + S.money(v.compare_at_price) + '</s>' : '') +
        '<span class="price__now">' + S.money(v.price) + '</span></span>';
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, (+qtyInput.value || 1) + (+b.getAttribute('data-qty-step'))); });
    });
    function submit(e, btn) {
      e.preventDefault();
      S.addToCart([{ id: +idInput.value, quantity: Math.max(1, +(qtyInput && qtyInput.value) || 1) }], btn);
    }
    if (form) form.addEventListener('submit', function (e) { submit(e, $('[data-atc]', form)); });
    $$('[data-atc-sticky]', root).forEach(function (b) { b.addEventListener('click', function (e) { submit(e, b); }); });

    // Barre d'achat collante (mobile)
    var sticky = $('[data-sticky-atc]', root), main = $('[data-atc]', form);
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(main);
    }
    // Miniatures
    $$('[data-thumb]', root).forEach(function (t, k) {
      t.addEventListener('click', function () {
        var gal = $('.pm-gallery .slider', root); if (gal && gal._sliderGo) gal._sliderGo(k);
        $$('[data-thumb]', root).forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }

  /* ---------- Lot (bundle) de la page produit ---------- */
  function initBundle(root) {
    var tiers = S.tiers;
    var items = $$('[data-bundle-item]', root);
    var btn = $('[data-bundle-add]', root);
    function refresh() {
      var sel = items.filter(function (it) { var c = $('input[type="checkbox"]', it); return c && c.checked; });
      var n = sel.length;
      var st = sel.reduce(function (s, it) { return s + (+it.getAttribute('data-price')); }, 0);
      var r = S.discountFor(n, tiers), gain = Math.round(st * r / 100);
      items.forEach(function (it) { var c = $('input[type="checkbox"]', it); it.classList.toggle('is-on', !!(c && c.checked)); });
      var set = function (k, v) { $$('[data-b-' + k + ']', root).forEach(function (el) { el.textContent = v; }); };
      set('count', n); set('pct', S.pct(r)); set('total', S.money(st - gain)); set('was', gain ? S.money(st) : ''); set('gain', gain ? S.money(gain) : S.money(0));
      var nx = S.nextTier(n, tiers);
      set('msg', nx ? root.getAttribute('data-msg-next').replace('[n]', nx[0] - n).replace('[pct]', S.pct(nx[1])) : root.getAttribute('data-msg-max').replace('[pct]', S.pct(r)));
      if (btn) btn.disabled = n === 0;
    }
    root.addEventListener('change', refresh);
    if (btn) btn.addEventListener('click', function () {
      var list = items.filter(function (it) { var c = $('input[type="checkbox"]', it); return c && c.checked; })
        .map(function (it) { var s = $('select', it); return { id: +(s ? s.value : it.getAttribute('data-variant')), quantity: 1 }; });
      if (!list.length) return;
      S.addToCart(list, btn).then(function () {
        var code = S.codeFor(list.length);
        if (code) fetch('/discount/' + encodeURIComponent(code));
      });
    });
    var cur = $('[data-current]', root);
    if (cur) document.addEventListener('variant:change', function (e) {
      var v = e.detail; cur.setAttribute('data-variant', v.id); cur.setAttribute('data-price', v.price);
      var pr = $('.bdl__price', cur); if (pr) pr.textContent = S.money(v.price);
      var cb = $('input[type="checkbox"]', cur); if (cb) { cb.disabled = !v.available; if (!v.available) cb.checked = false; }
      refresh();
    });
    $$('select', root).forEach(function (s) {
      s.addEventListener('change', function () {
        var opt = s.options[s.selectedIndex]; var it = s.closest('[data-bundle-item]');
        it.setAttribute('data-price', opt.getAttribute('data-price')); refresh();
      });
    });
    refresh();
  }

  /* ---------- Jauge animée « Compose ton coffret » (accueil) ---------- */
  function initGauge(root) {
    var cases = $$('[data-case]', root); if (!cases.length) return;
    var tiers = S.parseTiers(root.getAttribute('data-tiers')) ; if (!tiers.length) tiers = S.tiers;
    var prices = cases.map(function (c) { return (+c.getAttribute('data-price') || 0); });
    var N = cases.length, rail = $('[data-rail]', root), sel = [], timers = [], shown = { t: 0, e: 0 }, target = 0, rafs = {}, manual = false;
    var speed = +root.getAttribute('data-speed') || 720;
    function later(f, ms) { timers.push(setTimeout(f, ms)); }
    function stop() { timers.forEach(clearTimeout); timers = []; }
    function bump(el, cls) { if (S.reduced || !el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
    function roll(key, to, write) {
      cancelAnimationFrame(rafs[key]);
      var from = shown[key], t0 = performance.now(), d = S.reduced ? 0 : 650;
      var stepF = function (now) {
        var k = d ? Math.min(1, (now - t0) / d) : 1, e = 1 - Math.pow(1 - k, 3);
        shown[key] = from + (to - from) * e; write(shown[key]);
        if (k < 1) rafs[key] = requestAnimationFrame(stepF);
      };
      rafs[key] = requestAnimationFrame(stepF);
    }
    // marqueurs
    for (var k = 1; k <= N; k++) {
      var m = document.createElement('span'); m.className = 'tiers__mk'; m.setAttribute('data-k', k);
      m.style.left = (N > 1 ? (k - 1) / (N - 1) * 100 : 0) + '%';
      var rem = S.discountFor(k, tiers);
      if (k > 1 && rem !== S.discountFor(k - 1, tiers)) { var sm = document.createElement('small'); sm.textContent = S.pct(rem); m.appendChild(sm); }
      rail.appendChild(m);
    }
    var marks = $$('.tiers__mk', rail);
    function render(added) {
      var n = sel.length, r = S.discountFor(n, tiers);
      var tot = sel.reduce(function (s, i) { return s + prices[i]; }, 0), eco = Math.round(tot * r / 100);
      cases.forEach(function (c, i) { var on = sel.indexOf(i) > -1; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); });
      $('.tiers__fill', root).style.width = (n <= 1 || N < 2 ? 0 : (Math.min(n, N) - 1) / (N - 1) * 100) + '%';
      marks.forEach(function (m) { var kk = +m.getAttribute('data-k'), ok = kk > 1 && n >= kk; m.classList.toggle('is-ok', ok); if (added && kk === n && kk > 1) bump(m, 'ping'); });
      var rb = $('[data-g-pct]', root); if (rb.textContent !== S.pct(r)) { rb.textContent = S.pct(r); bump(rb, 'roll'); }
      roll('t', tot - eco, function (v) { $('[data-g-total]', root).textContent = S.money(v); });
      $('[data-g-was]', root).textContent = eco ? S.money(tot) : '';
      var eb = $('[data-g-eco]', root);
      roll('e', eco, function (v) { eb.textContent = S.money(v); });
      if (eco > target && !S.reduced) {
        bump(eb, 'pop');
        var dl = document.createElement('span'); dl.className = 'g-delta'; dl.textContent = '+' + S.money(eco - target);
        $('.g-amount', root).appendChild(dl); setTimeout(function () { dl.remove(); }, 1200);
      }
      target = eco;
      var b = $('[data-g-badge]', root); if (b && b.textContent !== S.pct(r)) { b.textContent = S.pct(r); if (n >= 2) bump(b, 'pop'); }
      root.classList.toggle('is-two', r > 0); root.classList.toggle('is-max', n >= N);
    }
    function cycle() {
      stop(); sel = []; render(false);
      for (var k2 = 0; k2 < N; k2++) (function (kk) { later(function () { sel.push(kk); render(true); }, 600 + kk * speed); })(k2);
      later(function () {
        for (var k3 = 0; k3 < N; k3++) (function (kk) { later(function () { sel = sel.filter(function (x) { return x !== N - 1 - kk; }); render(false); }, kk * 70); })(k3);
        later(cycle, 1100);
      }, 600 + N * speed + 2800);
    }
    cases.forEach(function (c, i) {
      c.addEventListener('click', function () {
        stop(); manual = true;
        if (sel.indexOf(i) > -1) { sel = sel.filter(function (x) { return x !== i; }); render(false); } else { sel.push(i); render(true); }
      });
    });
    render(false);
    if (S.reduced) { sel = cases.map(function (_, i) { return i; }); render(false); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var vu = es.some(function (e) { return e.isIntersecting; });
        root.classList.toggle('is-seen', vu);
        if (manual) return;
        if (vu) cycle(); else stop();
      }, { threshold: 0.35 }).observe(root);
    }
  }

  /* ---------- Page « Compose ton coffret » ---------- */
  function initCoffret(root) {
    var dataEl = $('[data-coffret-json]', root); if (!dataEl) return;
    var products = []; try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; }
    var tiers = S.tiers, MIN = tiers.length ? tiers[0][0] : 2;
    var maxSlots = tiers.length ? tiers[tiers.length - 1][0] : 5;
    var cart = {}, choice = {}, cat = '*';
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var T = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    var grid = $('[data-grid]', root);

    // jauge
    var rail = $('[data-rail]', root);
    var first = tiers.length ? tiers[0][0] : 1, last = maxSlots;
    tiers.forEach(function (t) {
      var m = document.createElement('span'); m.className = 'tiers__mk'; m.setAttribute('data-mk', t[0]);
      m.style.left = (last > first ? (t[0] - first) / (last - first) * 100 : 0) + '%';
      m.innerHTML = '<small>' + S.pct(t[1]) + '</small>'; rail.appendChild(m);
    });

    // onglets
    var cats = [];
    products.forEach(function (p) { if (cats.indexOf(p.cat) < 0) cats.push(p.cat); });
    var tabsHtml = (root.hasAttribute('data-all') ? ['*'] : []).concat(cats).map(function (c, i) {
      return '<button type="button" class="pill" role="tab" aria-selected="' + (i === 0) + '" data-cat="' + esc(c) + '">' + esc(c === '*' ? T('all') : c) + '</button>';
    }).join('');
    $('[data-tabs]', root).innerHTML = tabsHtml;
    cat = root.hasAttribute('data-all') ? '*' : (cats[0] || '*');

    grid.innerHTML = products.map(function (p, i) {
      var avail = p.v.filter(function (v) { return v.ok; });
      var sel = '';
      if (p.v.length > 1) {
        sel = '<select class="field cf-var" data-i="' + i + '" aria-label="' + esc(p.t) + '">' + p.v.map(function (v, j) {
          return '<option value="' + j + '"' + (v.ok ? '' : ' disabled') + '>' + esc(v.t) + (v.ok ? '' : ' — ' + esc(S.strings.soldOut)) + ' · ' + S.money(v.p) + '</option>';
        }).join('') + '</select>';
        choice[i] = Math.max(0, p.v.indexOf(avail[0]));
      } else choice[i] = 0;
      return '<article class="cf-p" data-i="' + i + '" data-cat="' + esc(p.cat) + '">' +
        '<a class="cf-p__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + (p.b ? '<span class="badge">' + esc(p.b) + '</span>' : '') + '</a>' +
        '<h3 class="cf-p__t"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' + (p.s ? '<p class="cf-p__s">' + esc(p.s) + '</p>' : '') + sel +
        '<div class="cf-p__act" data-act="' + i + '"></div></article>';
    }).join('');
    if (!products.length) $('[data-empty]', root).hidden = false;

    function variantOf(i) { return products[i].v[choice[i]] || products[i].v[0]; }
    function renderCards() {
      $$('.cf-p', grid).forEach(function (el) {
        var i = +el.getAttribute('data-i'), v = variantOf(i), act = $('[data-act]', el), line = cart[v.id];
        el.classList.toggle('is-on', !!line);
        if (!v.ok) { act.innerHTML = '<button type="button" class="card__btn" disabled><span>' + esc(S.strings.soldOut) + '</span></button>'; return; }
        act.innerHTML = line
          ? '<div class="qty cf-qty"><button type="button" data-minus="' + v.id + '" aria-label="-1">−</button><span>' + line.q + '</span><button type="button" data-plus="' + v.id + '" aria-label="+1">+</button></div>'
          : '<button type="button" class="card__btn card__btn--filled" data-add="' + v.id + '" data-i="' + i + '"><span>' + esc(T('add')) + '</span><span class="card__btn-sep"></span><span class="price">' + S.money(v.p) + '</span></button>';
      });
    }
    function filter() {
      $$('.cf-p', grid).forEach(function (el) { el.hidden = !(cat === '*' || el.getAttribute('data-cat') === cat); });
      $$('[data-cat]', $('[data-tabs]', root)).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-cat') === cat); });
    }
    function plural(n, w) { return n + ' ' + w + (n > 1 ? 's' : ''); }
    function render() {
      var lines = Object.keys(cart).map(function (k) { return cart[k]; });
      var n = lines.reduce(function (s, l) { return s + l.q; }, 0);
      var st = lines.reduce(function (s, l) { return s + l.q * l.v.p; }, 0);
      var r = S.discountFor(n, tiers), gain = Math.round(st * r / 100), total = st - gain;
      var set = function (k, v, html) { $$('[data-' + k + ']', root).forEach(function (el) { if (html) el.innerHTML = v; else el.textContent = v; }); };
      set('nb', plural(n, T('product'))); set('pct', S.pct(r)); set('st', S.money(st)); set('total', S.money(total));
      set('bnb', plural(n, T('product')) + (r ? ' · ' + S.pct(r) : ''));
      $$('[data-gainl]', root).forEach(function (el) { el.hidden = !gain; }); set('gain', '-' + S.money(gain));
      var nx = S.nextTier(n, tiers), msg;
      if (!nx) msg = T('max').replace('[pct]', '<b>' + S.pct(r) + '</b>');
      else msg = T('next').replace('[n]', plural(nx[0] - n, T('product'))).replace('[pct]', '<b>' + S.pct(nx[1]) + '</b>');
      set('msg', msg, true);
      $('[data-fill]', root).style.width = (n < first ? 0 : Math.min(100, (Math.min(n, last) - first) / Math.max(1, last - first) * 100)) + '%';
      $$('[data-mk]', rail).forEach(function (m) { m.classList.toggle('is-ok', n >= +m.getAttribute('data-mk')); });
      var imgs = []; lines.forEach(function (l) { for (var q = 0; q < l.q; q++) imgs.push(l.p.img); });
      var slots = '';
      for (var s = 0; s < maxSlots; s++) {
        var lab = ''; tiers.forEach(function (t) { if (t[0] === s + 1) lab = S.pct(t[1]); });
        slots += '<div class="cf-slot' + (s < n ? ' is-on' : '') + '"><i>' + (imgs[s] ? '<img src="' + esc(imgs[s]) + '" alt="">' : '') + '</i><span>' + lab + '</span></div>';
      }
      $('[data-slots]', root).innerHTML = slots;
      $('[data-lines]', root).innerHTML = lines.map(function (l) {
        var sub = l.p.v.length > 1 ? ' · ' + esc(l.v.t) : '';
        return '<li class="cf-line">' + (l.p.img ? '<img src="' + esc(l.p.img) + '" alt="">' : '<span></span>') + '<div><b>' + esc(l.p.t) + sub + '</b>' + l.q + ' × ' + S.money(l.v.p) + '</div><button type="button" data-rm="' + l.v.id + '">' + esc(T('remove')) + '</button></li>';
      }).join('');
      $$('[data-cta]', root).forEach(function (b) {
        b.disabled = n < MIN;
        b.textContent = n < MIN ? T('min').replace('[n]', plural(MIN - n, T('product'))) : T('cta');
      });
      renderCards();
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      var a;
      if ((a = t.getAttribute('data-add'))) { var i = +t.getAttribute('data-i'); var v = variantOf(i); if (!cart[a]) cart[a] = { q: 0, p: products[i], v: v }; cart[a].q++; render(); return; }
      if ((a = t.getAttribute('data-plus'))) { cart[a].q++; render(); return; }
      if ((a = t.getAttribute('data-minus'))) { cart[a].q--; if (cart[a].q <= 0) delete cart[a]; render(); return; }
      if ((a = t.getAttribute('data-rm'))) { delete cart[a]; render(); return; }
      if (t.hasAttribute('data-cat')) { cat = t.getAttribute('data-cat'); filter(); return; }
      if (t.hasAttribute('data-cta') && !t.disabled) validate(t);
    });
    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('cf-var')) { choice[+e.target.getAttribute('data-i')] = +e.target.value; renderCards(); }
    });
    function validate(btn) {
      var lines = Object.keys(cart).map(function (k) { return cart[k]; });
      var n = lines.reduce(function (s, l) { return s + l.q; }, 0);
      var err = $('[data-err]', root); err.hidden = true;
      $$('[data-cta]', root).forEach(function (b) { b.disabled = true; });
      btn.classList.add('is-loading');
      S.cart.add(lines.map(function (l) { return { id: l.v.id, quantity: l.q, properties: { _coffret: '1' } }; }))
        .then(function () {
          var code = S.codeFor(n);
          window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(S.routes.cart) : S.routes.cart;
        })
        .catch(function (er) {
          btn.classList.remove('is-loading');
          err.textContent = (er && er.description) || S.strings.error; err.hidden = false; render();
        });
    }
    filter(); render();
  }

  /* ---------- Quiz « Quelle est votre signature ? » ---------- */
  function initQuiz(root) {
    var dataEl = $('[data-quiz-json]', root); if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var results = data.results, questions = data.questions;
    var box = $('[data-questions]', root), scores = [];
    questions.forEach(function (q, i) {
      var div = document.createElement('div'); div.className = 'qz-step'; div.setAttribute('data-step', 'q' + i);
      var h = '<div class="qz-bar"><span style="width:' + (i / questions.length * 100) + '%"></span></div>' +
        '<div class="qz-num">' + (data.label || 'Question') + ' ' + (i + 1) + ' / ' + questions.length + '</div>' +
        '<h2 class="s-title qz-q">' + q.q + '</h2><div class="qz-opts">';
      q.r.forEach(function (r, j) { h += '<button type="button" class="qz-opt" data-q="' + i + '" data-r="' + j + '">' + r.t + '</button>'; });
      h += '</div>' + (i > 0 ? '<button type="button" class="qz-back" data-back="' + i + '">' + (data.back || '← Retour') + '</button>' : '');
      div.innerHTML = h; box.appendChild(div);
    });
    function show(name) {
      $$('.qz-step', root).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-step') === name); });
      if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function start() { scores = []; show('q0'); }
    function finish() {
      var total = {}; Object.keys(results).forEach(function (k) { total[k] = 0; });
      scores.forEach(function (pts) { Object.keys(pts).forEach(function (k) { if (k in total) total[k] += pts[k]; }); });
      var order = Object.keys(total).sort(function (a, b) { return total[b] - total[a]; });
      var win = results[order[0]], second = results[order[1]];
      if (!win) return;
      $('[data-r-name]', root).textContent = win.name;
      $('[data-r-desc]', root).textContent = win.desc;
      $('[data-r-notes]', root).textContent = win.notes;
      var img = $('[data-r-img]', root);
      if (img) { img.hidden = !win.img; if (win.img) { img.src = win.img; img.alt = win.name; } }
      var link = $('[data-r-link]', root); link.href = win.link || '#';
      var sec = $('[data-r-second]', root);
      if (sec) sec.innerHTML = second ? (data.also || '') + ' <a href="' + (second.link || '#') + '">' + second.name + '</a>' : '';
      try { sessionStorage.setItem('siryana-signature', order[0]); } catch (e) {}
      show('result');
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-quiz-start]')) { start(); return; }
      var o = e.target.closest('.qz-opt');
      if (o) {
        var i = +o.getAttribute('data-q'), j = +o.getAttribute('data-r');
        scores[i] = questions[i].r[j].p;
        if (i + 1 < questions.length) show('q' + (i + 1)); else finish();
        return;
      }
      var b = e.target.closest('[data-back]');
      if (b) show('q' + (+b.getAttribute('data-back') - 1));
    });
  }

  /* ---------- Révélation au défilement ---------- */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length || !('IntersectionObserver' in window) || S.reduced) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Initialisation (et rechargement dans l'éditeur de thème) ---------- */
  var inits = {
    announcement: initAnnouncement, header: initHeader, slider: initSlider, tabs: initTabs,
    scents: initScents, product: initProduct, bundle: initBundle, gauge: initGauge, coffret: initCoffret, quiz: initQuiz
  };
  function boot(scope) {
    var list = $$('[data-init]', scope);
    if (scope && scope.matches && scope.matches('[data-init]')) list.unshift(scope);
    list.forEach(function (el) {
      if (el._booted) return; el._booted = true;
      el.getAttribute('data-init').split(' ').forEach(function (n) { if (inits[n]) { try { inits[n](el); } catch (err) { console.error('Siryana:', n, err); } } });
    });
    initReveal();
  }
  S.boot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
